import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import { pluralizeToString } from 'lib/string/pluralize'
import Group from 'components/utils/Group'
import Select from 'components/Common/Form/Input/Select'

interface Props {
  duration: number
  setStep: (step: BnblSteps) => void
}

export function BnblPackageDuration({ duration, setStep }: Props) {
  const intl = useIntl()
  const onChangeDuration = useCallback(() => {
    setStep(BnblSteps.CHANGE_DURATION)
  }, [setStep])

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
      <BodyText variant="large" weight="bold">{intl.formatMessage({
        id: '++dUqX35zS',
        defaultMessage: 'Length of stay',
        description: 'Label for the duration selector in BNBL package configuration',
      })}
      </BodyText>
      {/* TODO: i18n - 💲 pluralizeToString('night', duration) is a pricing/duration unit, needs special handling */}
      <Select
        value={pluralizeToString('night', duration)}
        onClick={onChangeDuration}
        onMouseDown={e => e.preventDefault()} // Prevents the dropdown from opening
        noValidationSpacing
      >
        <option>{pluralizeToString('night', duration)}</option>
      </Select>
    </Group>
  )
}
